<div class='InfoTips'>
  <div class='InfoTips-title'>
    <h3>{{ getTitle() }}</h3>
  </div>
  <div class='InfoTips-content pl-4 pt-4'>
    <ng-container *ngIf="type === 'meeting'">
      <p>Congratulations on setting a meeting! Select the date of the meeting and populate the start and stop
        time. Fill in the Location and Subject.<br><br>Expected behavior: Confirmation email will be sent to
        contact. Contact email will disappear from your inbox and contact will be moved to the "Meeting" tab
        under your Inbox.<br><br>Important! - For every reply action you have the choice to select "Send" or
        "Update". "Send" will disposition the contact and schedule all future activity (if appropriate) AND send
        immediate reply email. "Update" will disposition the contact and schedule all future activity (if
        appropriate) AND WILL NOT send immediate reply email. "Update" is often used if you speak to the contact
        on the phone or if you receive an email directly in your personal email inbox.</p>
    </ng-container>
    <ng-container *ngIf="type === 'lock_domain'">
      <p>The "Locked Domains Management" feature allows you to create more granular contact segmentation for your subordinates.</p>
      <p>You can enter a domain and select one or more subordinate users who will be allowed to work with contacts whose email addresses end with the specified domain.</p>
      <p>The selected users will be whitelisted for that domain.</p>
      <p>All other subordinates who are not selected for a given domain will not be able to create contacts with email addresses ending in the locked domain.</p>
      <p>If you want to completely restrict a domain for all subordinates, use the "Block for All" option.</p>
      <p>You can edit and delete only the domains that you have created.</p>
    </ng-container>
    <ng-container *ngIf="type === 'cycle'">
      <p>If a contact replies that they are not interested now, select "Cycle" reply. Select which Cycle makes
        sense for that contact (every month, every three months, every six months, every nine months or every 12
        months).<br><br>Expected behavior: Email will be sent to the contact confirming your intent to keep in
        touch. You will see a preview of the email that will be sent on the future cycle date. Approve or Edit
        the future email. Contact email will disappear from your inbox and contact will be moved to the "Cycle"
        tab under your inbox.<br>No further action, Retreva&reg; will send the email to the contact on the
        date you selected. Additionally, if the contact does not reply, Retreva&reg; will reach out to the
        contact again every # months (whichever cycle you selected) to maximize your chances of converting this
        contact to a meeting.<br><br>Important! - For every reply action you have the choice to select "Send" or
        "Update". "Send" will disposition the contact and schedule all future activity (if appropriate) AND send
        immediate reply email. "Update" will disposition the contact and schedule all future activity (if
        appropriate) AND WILL NOT send immediate reply email. "Update" is often used if you speak to the contact
        on the phone or if you receive an email directly in your personal email inbox.</p>
    </ng-container>
    <ng-container *ngIf="type === 'cycle_2'">
      <p>Cycle shows you all contacts that you currently have a cycle scheduled for. No need to manage your
        cycles. Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> does that for you. The
        email you approved when you selected the cycle response will be automatically sent on the cycle interval
        you selected. If the contact does not respond, Retreva<span
          style='font-size:9px; vertical-align: super'>&reg;</span> will continue to reach out every 3, 6,
        9 or 12 months (whichever was selected)</p>
    </ng-container>
    <ng-container *ngIf="type === 'follow_up' || type === 'followup' ">
      <p>When a contact asks for follow up on a specific date in the future, select “Follow Up” reply. Select the
        date you would like the follow up email to be sent.<br><br>Expected behavior: Email will be sent to the
        contact confirming the future follow up. You will see a preview of the email that will be sent on the
        future date. Approve or Edit the future email. Contact will disappear from your inbox and contact email
        will be moved to the "Follow Up" tab under your inbox.<br><br>No further action, Retreva&reg; will
        send the email to the contact on the date you selected. Additionally, if the contact does not reply,
        Retreva&reg; will reach out to the contact again and place them in a less aggressive campaign to
        maximize your chances of converting this contact to a meeting.<br><br>Important! - For every reply
        action you have the choice to select "Send" or "Update". "Send" will disposition the contact and
        schedule all future activity (if appropriate) AND send immediate reply email. "Update" will disposition
        the contact and schedule all future activity (if appropriate) AND WILL NOT send immediate reply email.
        "Update" is often used if you speak to the contact on the phone or if you receive an email directly in
        your personal email inbox.</p>
    </ng-container>
    <ng-container *ngIf="type === 'follow_up_2'">
      <p>Follow Up shows you all contacts that you currently have a follow up scheduled for. No need to manage
        your follow ups. Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> does that for
        you. The email you approved when you selected the follow up will be automatically sent on the date you
        selected. If the contact does not respond. Retreva<span
          style='font-size:9px; vertical-align: super'>&reg;</span>
        will resend it a few times and then drop the contact in a less aggressive campaign.</p>
    </ng-container>
    <ng-container *ngIf="type === 'inactive'">
      <p>If it does not make sense to continue dialog with a contact, select "Inactive" reply. Select the reason
        you are making the contact inactive (Wrong Person, Not a good fit, Out of business, or Other).<br><br>Expected
        behavior: Email will be sent to the contact. Contact will disappear from your inbox and contact email
        will be moved to "Inactive" tab under your inbox.<br><br>Important! - For every reply action you have
        the choice to select "Send" or "Update". "Send" will disposition the contact and schedule all future
        activity (if appropriate) AND send immediate reply email. "Update" will disposition the contact and
        schedule all future activity (if appropriate) AND WILL NOT send immediate reply email. "Update" is often
        used if you speak to the contact on the phone or if you receive an email directly in your personal email
        inbox.</p>
    </ng-container>
    <ng-container *ngIf="type === 'remove'">
      <p>If a contact asked to be removed or unsubscribed, select "Remove" reply. Remove should only be used for
        people who have asked to be removed. All other contacts should be Inactive (never email again) or Cycle
        (less aggressive).<br><br>Expected behavior: Email will be sent to the contact confirming they have been
        removed. Contact email will disappear from your inbox and contact will be moved to the "Remove" tab
        under your inbox.<br><br>Important! - For every reply action you have the choice to select "Send" or
        "Update". "Send" will disposition the contact and schedule all future activity (if appropriate) AND send
        immediate reply email. "Update" will disposition the contact and schedule all future activity (if
        appropriate) AND WILL NOT send immediate reply email. "Update" is often used if you speak to the contact
        on the phone or if you receive an email directly in your personal email inbox.</p>
    </ng-container>
    <ng-container *ngIf="type === 'conversation'">
      <p>When a contact asks a specific question or additional dialogue is required, select "Conversation" reply.
        You will be presented a blank text box to type a customized reply to the contact.<br><br>Expected
        behavior: Email will be sent to the contact. Contact email will remain in your inbox and future campaign
        emails will not be sent. Choose a different reply action based on contact's reply or select conversation
        again if you need to have additional dialog.</p>
    </ng-container>
    <ng-container *ngIf="type === 'enter_activity'">
      <p>Enter Activity allows you to log a note or a phone call. To view contact history click the green Activity
        button on the contact view.</p>
    </ng-container>
    <ng-container *ngIf="type === 'opportunities'">
      <p>The Opportunity sub folders are a quick way to track your ROI with Retreva and to follow up with
        customers and prospects. Order is used to track sales right from your Retreva Inbox. Meeting helps
        you keep your calendar organized and sends a meeting invite to you, your prospect and anyone else you
        added. Note, when you use Order, it will automatically create a Meeting record for reporting. This will
        NOT send a meeting invite to anyone. It is simply a record to track your Order.</p>
    </ng-container>
    <ng-container *ngIf="type === 'order'">
      <p>Order is a quick way to track sales from Retreva right from your Retreva Inbox. If you close a
        sale, simply select the Order reply action. Pick the date, enter the dollar amount and save. The order
        will automatically roll up to sales reports. Note, when you use Order, it will automatically create a
        Meeting record for reporting. This will NOT send a meeting invite to anyone. It is simply a record to
        track your Order.</p>
    </ng-container>
    <ng-container *ngIf="type === 'forward'">
      <p>When a contact sends you an attachment that you cannot view in Retreva&reg; or you want to take the
        email conversation to your own email inbox, simply select “Forward”. Expected behavior: Email will be
        forwarded to your email (email address supplied during account creation). Contact email will remain in
        your inbox while you take the email conversation “off-line”. Choose a different reply action when you
        are done with your conversation. Note, if you take the conversation “off-line” the history will not be
        stored in Retreva&reg;.</p>
    </ng-container>
    <ng-container *ngIf="type === 'ok_got_it'">
      <p>There will be times when a message will just need to be deleted from the inbox with no further action
        required. This will typically happen when the reply is an Out of Office notification or a contact
        replies back with a thank you or with additional information that does not require a reply.

        Expected behavior: The message will simply be removed from your inbox and the contact will remain in
        their current reply status.

        <b>"Keep Current Status" is an inbox cleaning tool.</b> "Keep Current Status" is only used to remove an
        email from the inbox. It keeps the contact in their current status. So, if they were in a campaign and
        you selected "Keep Current Status" they will remain in the campaign and continue to get campaign emails.

        "Keep Current Status" is used for out of office replies or if you sent someone a Cycle or Follow Up,
        etc. response and they responded back “Thanks!”, you would use "Keep Current Status" to remove the
        “Thanks!” email from the inbox and keep them in Cycle or Follow Up, etc.</p>
    </ng-container>
    <ng-container *ngIf="type === 'contacts'">
      <div class='InfoTips-content-contacts'>
        <p>Adding contacts is the key to your success. The more contacts you add the more sales activity
          Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> will generate for you.</p>
        <p>
          There are three ways to add a contact. You can upload a CSV or Excel file by clicking Upload. You can
          manually add a contact by selecting "Add Contact" and you can purchase contacts through Retreva<span
          style='font-size:9px; vertical-align: super'>&reg;</span> by selecting "Purchase Credits".
        </p>
        <p>
          Important! When adding contacts, select the appropriate group to make sure your contacts receive the
          right content. You can also select "Add New Group" if you want to add your contacts to a new group.
        </p>
        <p>
          Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> tracks when every contact is
          added. Each contact is on their own campaign cycle. So, you can easily add contacts to an existing group and
          they will receive the first campaign email while other contacts in the group may be on email 3 or 4 or 15.
        </p>
        <br>
        <p class='extra mt-3'>
          JUST KEEP ADDING THEM. <span class='tip'>TIP:</span> Try to always have 1000 ACTIVE contacts!
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="type === 'active_total'">
      <p>The "Total" number of contacts is the total number of contacts you have added to the contact group. The
        "Active" number of contacts is the number of contacts that are still eligible to receive campaign emails
        (contacts that have a reply action, are in your inbox, or have email addresses that have bounced back are not
        included). The "In Campaign" number of contacts is the number of contacts that are eligible to receive campaign
        emails AND are currently running within a campaign.</p>
    </ng-container>
    <ng-container *ngIf="type === 'status'">
      <p>This column represents the current campaign status for your contact groups.</p>
      <br>
      <p>Green=Your contact group is assigned to an active campaign and your contacts will receive campaign
        emails.</p>
      <p>Yellow=Your contact group is assigned to a pending campaign and your contacts will not receive campaign
        emails until you reactive your campaign.</p>
      <p>Red=Your contact group is assigned to a deleted campaign and your contacts will not receive campaign
        emails.</p>
      <br>
      <p>Note, contact groups assigned to No Campaign or not assigned to a campaign yet do not have a status
        assigned and contacts will not receive campaign emails.</p>
    </ng-container>
    <ng-container *ngIf="type === 'status_accounts'">
      <h4>If the user does not have Edge support:</h4>

      <p>
        <span style="display:inline-block;width:12px;height:12px;border-radius:50%;background:#e74c3c;margin-right:6px;"></span>
        <strong>Red dot:</strong> Displayed if any of the following conditions are met:
      </p>
      <ul>
        <li>More than 15 unread messages</li>
        <li>Unread messages older than 3 days</li>
        <li>More than 3 unknown messages</li>
      </ul>
      
      <p>
        <span style="display:inline-block;width:12px;height:12px;border-radius:50%;background:#f1c40f;margin-right:6px;"></span>
        <strong>Yellow dot:</strong> Displayed if any of the following conditions are met:
      </p>
      <ul>
        <li>10 or more unread messages</li>
        <li>Unread messages that are 1 day old or older</li>
        <li>2 or more unknown messages</li>
      </ul>
      
      <p>
        <span style="display:inline-block;width:12px;height:12px;border-radius:50%;background:#2ecc71;margin-right:6px;"></span>
        <strong>Green dot:</strong> Displayed if none of the above conditions are met.
      </p>
      
      <h4 >If the user has Edge support:</h4>
      
      <p>
        <span style="display:inline-block;width:12px;height:12px;border-radius:50%;background:#8e44ad;margin-right:6px;"></span>
        <strong>Purple dot:</strong> Displayed if the user has at least one contact group (other than “No Campaign”) that:
      </p>
      <ul>
        <li>Is not assigned to any campaign, or</li>
        <li>Is assigned to a campaign that is pending (not running)</li>
      </ul>
      
      <p>
        <app-svg-renderer [svg]="'Dog Icon'" class="InfoTips-dog-icon"></app-svg-renderer>
        <strong> logo:</strong> Displayed if all contact groups (other than “No Campaign”) are assigned to campaigns and all assigned campaigns are currently running.
      </p>
    </ng-container>
    <ng-container *ngIf="type === 'content'">
      <b>Content Group:</b><br>
      You can change your content for outbound campaigns emails anytime. You can edit each email individually or
      check the small to apply a change to all 4 emails within the content group. If you make a change, the
      updated email will be used the next time that email template is used to generate a campaign email.<br><br>
      <b>Response Group:</b><br>
      You can edit suggested text when you are replying to an incoming email. Simply select the reply action you
      want to update, update the text and it will be presented the next time you choose that reply action.
      Remember to enter your Response Signature so your Signature is attached to all replies and conversations
      initiated from the contact view.<br><br>
      <b>Signature:</b><br>
      Retreva will use this signature for all outbound emails. Your signature should include your name,physical
      address, phone number and email.If you edit your signature, the changes will take place on all future
      outbound email.
    </ng-container>
    <ng-container *ngIf="type === 'content_group'">
      <b>Content Group:</b><br>
      You can edit suggested text when you are replying to an incoming email. Simply select the reply action you
      want to update, update the text and it will be presented the next time you choose that reply action.
      Remember to enter your Response Signature so your Signature is attached to all replies and conversations
      initiated from the contact view.
    </ng-container>
    <ng-container *ngIf="type === 'preview'">
      <p>Preview allows you to preview and edit your campaign content. If you edit the content, it will be used
        for all future outbound emails.</p>
    </ng-container>
    <ng-container *ngIf="type === 'test'">
      <p>Test allows you to see your campaign content as your contacts will see it. When you press Test,
        Retreva&reg; sends the email your are testing to the email address assigned to your Retreva&reg;
        account.</p>
    </ng-container>
    <ng-container *ngIf="type === 'campaign'">
      Use Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span>'s campaign wizard to create a
      new campaign in 4 easy steps.<p style='margin-left: 20px;'><br>1. Type a descriptive name for your campaign.<br>2.
      Select "Standard" Campaign to drive initial sales calls with prospective contacts. Or, select "Choose
      Frequency" to create a custom campaign for existing customers or groups of contacts you want to communicate
      with less frequently.<br>3. Write your content or select existing content.<br>4. Approve your content. If
      you would like to make changes, select the "Edit" option.</p><br>Campaign emails will continue to go out as
      long as the campaign is active. Emails are auto-generated by the system and sent based on a pre-determined
      schedule. Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span>'s campaign schedule was
      built over many years of sending thousands of emails and analyzing reply behavior. The Campaign Manager
      looks at several factors to determine when to send campaign emails like:<br><br>
      <ul style='margin-left: 30px'>
        <li type='square'>Time of day</li>
        <li type='square'>Day of week</li>
        <li type='square'>Holiday treatment</li>
        <li type='square'>Time between emails</li>
        <li type='square'>Length in campaign</li>
      </ul>
      <br>If you are going on vacation or do not want campaign emails to go out, simply make your campaign
      pending. You can activate your campaign when you are ready to start sending emails again.
    </ng-container>
    <ng-container *ngIf="type === 'campaign_name'">
      <p>Your Campaign name should be descriptive of the group of contacts that you are reaching out to. This may
        be descriptive based on industry, contact title, product or geography.</p>
    </ng-container>
    <ng-container *ngIf="type === 'select_content'">
      <p>You can select existing content or use a content code if you have one.</p>
    </ng-container>
    <ng-container *ngIf="type === 'request_help'">
      <p>Your content is very important to the success of your Retreva® campaign. Retreva® can write your
        content for you for $50.00. If you would like assistance, please click the "Request Help with Content"
        button and a content specialist will be in touch shortly.</p>
    </ng-container>
    <ng-container *ngIf="type === 'get_started_with_content'">
      <p>Choose your goal. Are you trying to drive your contacts to an onsite Meeting, a brief introductory phone
        call or are you trying to redirect them to your website or a landing page?.</p>
    </ng-container>
    <ng-container *ngIf="type === 'fill_in_the_blank'">
      <p>I would like to learn more about your ______ (e.g. IT infrastructure, hiring process, advertising goals,
        etc. DO NOT CAPITALIZE, unless it would always be written with capitalization.)</p>
    </ng-container>
    <ng-container *ngIf="type === 'attention_statement'">
      <h4>Example Attention Statements:</h4>
      <p>Our clients use Acme as a tool to connect targeted homeowners with a customized invitation to a product
        or service.</p>
      <p>Acme’s state of the art datacenter is located in downtown &lt;insert City&gt;, &lt;insert State&gt; and
        is designed to meet and exceed our client’s business and technical requirements.</p>
      <p>Acme understands that creating and maintaining a social media strategy is a lot of work. Our goal is
        simple; our clients do as little work as possible.</p>
      <p>Acme has been providing superior cleaning and janitorial supplies in the &lt;insert territory&gt; market
        since 1996.</p>
      <p>Acme’s &lt;insert product name&gt; inventory optimization solution is proven to deliver measurable
        results.</p>
      <p>I am checking in with you regarding your current real estate plans.&nbsp; I have over 15 years of
        experience representing landlords, sellers, buyers and tenants in the central &lt;Insert territory&gt;
        market.</p>
      <p>Acme’s strong partnership with several manufacturers allows us to work with our customers to make sure
        the most effective technology is deployed for each unique environment.</p>
    </ng-container>
    <ng-container *ngIf="type === 'explain_benefits'">
      <h4>Example Benefit Statements:</h4>
      <p>Over the last 17 years, my consultative approach has delivered significant ROI and positive sales impacts
        for my clients.&nbsp;Acme specializes in multi-media advertising including digital, SMS and direct
        mail.</p>
      <p>Acme’s experienced team is available to assist with needs assessment, design and planning,
        implementation, project management and other important functions of maintaining a secure datacenter.</p>
      <p>We understand the challenges that many of our clients face every day regarding regulations, data
        integrity and security and physical site limitations.&nbsp; Acme helps our clients by:</p>
      <li style='margin-left:30px;'>Keeping up-to-date and consulting on ever changing regulations</li>
      <li style='margin-left:30px;'>Offering a secure data facility as a primary or back up</li>
      <li style='margin-left:30px;'>Augmenting IT resources</li>
      <li style='margin-left:30px;'>Bringing peace of mind that business critical equipment and data is in a
        secure location
      </li>
      <p>Our team becomes an extension of your team saving clients significant time and money. Acme helps
        companies:</p>
      <li style='margin-left:30px;'>Connect with their customers</li>
      <li style='margin-left:30px;'>Write and create content as though companies wrote it themselves</li>
      <li style='margin-left:30px;'>Allows companies to maintain approval and control at all times</li>
      <li style='margin-left:30px;'>Manages all social media to maximize success</li>
      <p>I understand you may not have an immediate need to consider other vendors at this time but I would still
        like the opportunity to introduce Acme to you for future consideration. Companies often call us for
        consulting engagements, emergency services, special projects and supplies to consolidate vendors.</p>
      <p>Our customers have reduced their inventory by as much as 30% while achieving targeted service levels and
        delivering a solid return on investment. The rapid implementation of &lt;insert product name&gt; enables
        them to strategically complement existing ERP systems.</p>
      <p>I can help with existing lease negotiations, securing new space, strategic planning and investment
        opportunities.</p>
      <p>I understand that you may not have any immediate real estate needs but I would like the opportunity to
        learn more about your business, your future space needs and goals and share a little more about Acme and
        my experience.</p>
      <p>Many companies choose to meet with Acme for strategic planning sessions. Their intention is not to buy
        but to strategize on future initiatives so when budgets become available they are ahead of the curve and
        know exactly how to move forward.</p>
      <p>Many companies are being asked to perform as well or better with reduced staff. Our solutions help make
        this happen by bringing automation, increased efficiencies, enhanced features and superior reporting to
        contact center and business users.</p>
    </ng-container>
    <ng-container *ngIf="type === 'detailed_section'">
      <p>Retreva&reg; does not recommend that the content of the emails contain a lot of details. However, we
        understand that businesses sometimes require adding bulleted details that the contact will expect to see
        for a particular industry. If you feel you need to add many details to your emails add them to the
        detailed section in the content wizard. The bullets should be short and to the point and only include
        bullets that are very important. Be sure to reference the bullet points below in one of your benefit
        statements and Retreva&reg; will include the bullets after your signature.</p>
    </ng-container>
    <ng-container *ngIf="type === 'provide_signature'">
      <p>Your email signature should contain your full name, title, company, physical address, phone number, email
        address. You can also include your website and tag line if applicable. Note, Retreva&reg;
        automatically signs your emails with your first name so you should not add the email closing. This is
        just for your contact information.</p>
    </ng-container>
    <ng-container *ngIf="type === 'pipeline_feature'">
      <p>You can customize up to 10 pipeline stages. These stages can be used to report on opportunities and keep
        your sales on track. Examples of Pipeline Steps are: Data Gathering, Generating Proposal, Proposal
        Delivered, Negotiation, Verbal Commitment, Legal. Note, if you do not have this feature turned on, all
        meetings will have the default pipeline value of '0-Meeting set by Retreva&reg;.</p>
    </ng-container>
    <ng-container *ngIf="type === 'signature'">
      <p>Retreva&reg; will use this signature for all outbound emails. Please enter your signature into the box
        below. If you like to use your first name before the signature, please enter your first name followed by
        a return and your signature. Your signature should include your name, physical address, phone number and
        email.</p>
    </ng-container>
    <ng-container *ngIf="type === 'meeting_popup'">
      <p>Meeting shows you all contacts that you have set a meeting with. Click on Edit to add notes, assign a
        pipeline step and track your wins and losses. Click on a meeting to view details and export all contact
        information and history to a .csv or .vcf.</p>
    </ng-container>
    <ng-container *ngIf="type === 'followup_popup'">
      <p>Follow Up shows you all contacts that you currently have a follow up scheduled for. No need to manage
        your follow ups. Retreva® does that for you. The email you approved when you selected the follow up
        will be automatically sent on the date you selected. If the contact does not respond. Retreva® will
        resend it a few times and then drop the contact in a less aggressive campaign.</p>
    </ng-container>
    <ng-container *ngIf="type === 'cycle_popup'">
      <p>Cycle shows you all contacts that you currently have a cycle scheduled for. No need to manage your
        cycles. Retreva® does that for you. The email you approved when you selected the cycle response will
        be automatically sent on the cycle interval you selected. If the contact does not respond, Retreva®
        will continue to reach out every 3, 6, 9 or 12 months (whichever was selected)</p>
    </ng-container>
    <ng-container *ngIf="type === 'inactive_popup'">
      <p>Inactive shows you all contacts that you currently have flagged as Inactive. These contacts are no longer
        receiving any automated campaign emails.</p>
    </ng-container>
    <ng-container *ngIf="type === 'remove_popup'">
      <p>Remove shows you all contacts that you currently have flagged as Remove. These contacts are no longer
        receiving any automated campaign emails. Note, you can export these contacts to sync with other company
        communications to remain CAN-SPAM compliant.</p>
    </ng-container>
    <ng-container *ngIf="type === 'ok_got_it_popup'">
      <p>"Keep Current Status" is an inbox cleaning tool. "Keep Current Status" is only used to remove an email
        from the inbox. It keeps the contact in their current status. So, if they were in a campaign and you
        selected “Keep Current Status” they will remain in the campaign and continue to get campaign emails.<br><br>The
        only messages that should be in this "Keep Current Status" section are Out of Office Replies and System
        Messages. All other messages should be dispositioned as Meeting, Follow Up, Cycle, Inactive or Remove.
        If you have used the "Keep Current Status" status in error, simply click on the message, select
        "Response" and choose the appropriate reply action. Remember, "Update" does not send the initial reply
        but updates the contact and schedules future activity. "Send" does the same thing AND sends the initial
        reply.</p>
    </ng-container>
    <ng-container *ngIf="type === 'add_contacts'">
      You are about to add a single contact. You should have at least a valid first name and email address for
      each contact. Retreva<span style='font-size:9px; vertical-align: super'>®</span> recommends that you
      upload (at a minimum) for each contact:<br><br>
      <ul style='margin-left: 30px'>
        <li type='square'>First Name</li>
        <li type='square'>Last Name</li>
        <li type='square'>Company</li>
        <li type='square'>Email Address</li>
      </ul>
      <br>Additional fields may be uploaded as well.<br><br>You can select an existing group. If you select an
      existing group that is associated with a campaign, the new contact will be sent email 1.<br><br>Use Group
      “No Campaign” to add contacts that you do not want to receive campaign emails. This group can be used to add
      contacts that you want to schedule future activities (i.e. Follow Up or Cycle). You can also load clients
      and active prospects to No Campaign to make sure the contacts are assigned to your account and other reps
      (if you are in a multi-rep company) cannot upload them.
    </ng-container>
    <ng-container *ngIf="type === 'upload_contacts'">
      Follow the instructions to upload a .csv or Excel file. Make sure your data is clean. All email addresses
      should be formatted properly. First and last names must be in separate columns. The first name will be
      populated in the email so make sure they are proper first names with appropriate formatting (i.e. not all
      Caps, no middle initials, etc.).<br>You should have at least a valid first name and email address for each
      contact. Retreva<span style='font-size:9px; vertical-align: super'>®</span> recommends that you upload
      (at a minimum) for each contact:<br><br>
      <ul style='margin-left: 30px'>
        <li type='square'>First Name</li>
        <li type='square'>Last Name</li>
        <li type='square'>Company</li>
        <li type='square'>Email Address</li>
      </ul>
      <br>Additional fields may be uploaded as well.<br><br>Note, if you have multiple spreadsheets to upload, you
      must upload them individually. You can select the same group name to combine multiple lists into a single
      Retreva<span style='font-size:9px; vertical-align: super'>®</span> Contact Group.
    </ng-container>
    <ng-container *ngIf="type === 'complete_template_preview'">
      You have Successfully Created the {{ campaignName }} campaign. Next you should go to Contacts section and
      assign Contacts to your new Campaign.
    </ng-container>
    <ng-container *ngIf="type === 'update_send'">
      Update and Send do the same thing. The only difference is Update does not send the immediate email. So, if
      you simply want to update the contact to Meeting, Inactive or Remove status and NOT send them an email use
      Update. Also, if you want to schedule the future Follow Up or Cycle but not send the immediate email, use
      Update. If you hit Send, the immediate email will be sent to the contact.
    </ng-container>
    <ng-container *ngIf="type === 'deleted_meetings'">
      <p>Meetings should only be deleted if you dispositioned a meeting for testing purposes or by accident. All
        real sales activity should be set as “Lost” or “Won” under the Meeting sub inbox. You can always
        “Restore” a meeting if you deleted it by accident.</p>
    </ng-container>
    <ng-container *ngIf="type === 'inactive_2'">
      <p>Inactive shows you all contacts that you currently have flagged as Inactive. These contacts are no longer
        receiving any automated campaign emails.</p>
    </ng-container>
    <ng-container *ngIf="type === 'remove_2'">
      <p>Remove shows you all contacts that you currently have flagged as Remove. These contacts are no longer
        receiving any automated campaign emails. Note, you can export these contacts to sync with other company
        communications to remain CAN-SPAM compliant.</p>
    </ng-container>
    <ng-container *ngIf="type === 'ok_got_it_2'">
      <p>"Keep Current Status" is an inbox cleaning tool. "Keep Current Status" is only used to remove an email
        from the inbox. It keeps the contact in their current status. So, if they were in a campaign and you
        selected “Keep Current Status” they will remain in the campaign and continue to get campaign
        emails.<br /><br />The only messages that should be in this "Keep Current Status" section are Out of
        Office Replies and System Messages. All other messages should be dispositioned as Meeting, Follow Up,
        Cycle, Inactive or Remove. If you have used the "Keep Current Status" status in error, simply click on
        the message, select "Response" and choose the appropriate reply action. Remember, "Update" does not send
        the initial reply but updates the contact and schedules future activity. "Send" does the same thing AND
        sends the initial reply.</p>
    </ng-container>
    <ng-container *ngIf="type === 'spam'">
      <p>The service automatically filters incoming spam messages and files them here for your review.</p>
    </ng-container>
    <ng-container *ngIf="type === 'vip'">
      <p>The VIP feature allows you to flag your top prospects as VIP. Mixing a phone call into your prospecting
        cycle increases your chance of getting a reply. To flag a contact as VIP, check the VIP box on the
        contact view. When a contact is flagged as VIP, they will move to the VIP sub inbox approximately 7 days
        after the 3rd email is sent (or any email after the 3rd if you flagged the contact later in the campaign
        cycle).
        The contact will move to the VIP section when it is time to mix a phone call into your prospecting
        process. If you speak to the contact live, you can apply the appropriate reply action or press the left
        message button and send your follow up email.</p>
    </ng-container>
    <ng-container *ngIf="type === 'example_attention'">
      <p class='font-weight-bold'>Example Attention Statements:</p>
      <p>Our clients use Acme as a tool to connect targeted homeowners with a customized invitation to a product
        or service.
        Acme’s state of the art datacenter is located in downtown &lt;insert City&gt;, &lt;insert State&gt; and
        is designed to meet and exceed our client’s business and technical requirements.
        Acme understands that creating and maintaining a social media strategy is a lot of work. Our goal is
        simple; our clients do as little work as possible.
        Acme has been providing superior cleaning and janitorial supplies in the &lt;insert territory&gt; market
        since 1996.
        Acme’s &lt;insert product name&gt; inventory optimization solution is proven to deliver measurable
        results.
        I am checking in with you regarding your current real estate plans. I have over 15 years of experience
        representing landlords, sellers, buyers and tenants in the central &lt;Insert territory&gt; market.
        Acme’s strong partnership with several manufacturers allows us to work with our customers to make sure
        the most effective technology is deployed for each unique environment.
      </p>
      <p class='font-weight-bold'>Example Benefit Statements:</p>
      <p>
        Acme now offers more options than ever to geographically and demographically select the most relevant
        audience.
        Over the last 17 years, my consultative approach has delivered significant ROI and positive sales
        impacts for my clients. Acme specializes in multi-media advertising including digital, SMS and direct
        mail.
        Acme’s experienced team is available to assist with needs assessment, design and planning,
        implementation, project management and other important functions of maintaining a secure datacenter.
        We understand the challenges that many of our clients face every day regarding regulations, data
        integrity and security and physical site limitations. Acme helps our clients by:
      </p>
      <ul style='padding-left: 20px;'>
        <li style='list-style: disc;'>Keeping up-to-date and consulting on ever changing regulations</li>
        <li style='list-style: disc;'>Offering a secure data facility as a primary or back up</li>
        <li style='list-style: disc;'>Bringing peace of mind that business critical equipment and data is in a
          secure location
        </li>
        <li style='list-style: disc;'>
          Our team becomes an extension of your team saving clients significant time and money. Acme helps
          companies:
          <br>
          <ul style='padding-left: 20px; padding-top: 10px;'>
            <li style='list-style: disc;'>Connect with their customers</li>
            <li style='list-style: disc;'>Write and create content as though companies wrote it themselves
            </li>
            <li style='list-style: disc;'>Allows companies to maintain approval and control at all times
            </li>
            <li style='list-style: disc;'>Manages all social media to maximize success</li>
          </ul>
        </li>
      </ul>
      <p>I understand you may not have an immediate need to consider other vendors at this time but I would still
        like the opportunity to introduce Acme to you for future consideration. Companies often call us for
        consulting engagements, emergency services, special projects and supplies to consolidate vendors.
        Our customers have reduced their inventory by as much as 30% while achieving targeted service levels and
        delivering a solid return on investment. The rapid implementation of &lt;insert product name&gt; enables
        them to strategically complement existing ERP systems.
        I can help with existing lease negotiations, securing new space, strategic planning and investment
        opportunities.
        I understand that you may not have any immediate real estate needs but I would like the opportunity to
        learn more about your business, your future space needs and goals and share a little more about Acme and
        my experience.
        Many companies choose to meet with Acme for strategic planning sessions. Their intention is not to buy
        but to strategize on future initiatives so when budgets become available they are ahead of the curve and
        know exactly how to move forward.
        Many companies are being asked to perform as well or better with reduced staff. Our solutions help make
        this happen by bringing automation, increased efficiencies, enhanced features and superior reporting to
        contact center and business users.
      </p>
    </ng-container>
    <ng-container *ngIf="type === 'one-time-message'">
      <p><span class='font-weight-bold'>Warning!</span> The One-Time message feature was designed to be able to
        send important information to certain contact groups. It is NOT recommended to use with prospects.
        Typically, One-Time messages are used to communicate with customers or partners.</p>
      <br />
      <p>If you are using One-Time messages with prospects there is a good chance you will have a higher
        unsubscribe rate and it will negatively affect your Retreva campaign statistics. Additionally, it is
        important that you are following "content rules" when using the One-Time message feature so your
        messages do not come across as looking like Spam.</p>
      <br />
      <p>If you are unsure about your content, please send it to help@retreva.com for feedback prior to sending
        your One-Time message. Using the One-Time message feature incorrectly could result in the loss of the
        feature and possible account termination.</p>
      <br />
      <p>Are you sure you want to use the One-Time message feature?</p>
    </ng-container>
    <ng-container *ngIf="type === 'inbox_status'">
      The success of your Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> campaign is
      directly tied to a "clean" inbox. The only messages that should be in your inbox are contacts you are
      currently in conversation with. All other messages should have the correct reply action assigned. Your goal
      is to keep the Inbox Status at green. A green status is achieved when you have less than 10 messages in your
      inbox, 1 or no red emails (No Match condition) and no unread messages that are more than 3 days old. If you
      need help cleaning up your inbox, please refer to the support link to access training videos and the C2S
      Cheat sheet. <br> <br>Sent and Total show you the total number of outbound emails Retreva<span
      style='font-size:9px; vertical-align: super'>&reg;</span> has sent. <br /> The Sent total is the number
      of emails sent today. Total shows you the total number of emails Retreva has sent since you signed up.
      You can click on Total and choose to display the number of emails sent in the last 7 days, 3O days, 6 months
      and 1 year.
    </ng-container>
    <ng-container *ngIf="type === 'back_to_campaign'">
      This option will clear the reply action associated with this contact. The contact will continue to receive
      campaign emails of the campaign, assigned to the contact's group and contact will retain the email position
      they were on prior to the reply action being assigned.

    </ng-container>
    <ng-container *ngIf="type === 'no-match-action'">
      <p>We do not recognize this email. Either the contact forwarded your email or replied from an alternate
        email address. It is very important that you handle the red emails properly to avoid sending unwanted
        campaign emails. You must match this email to an existing contact or add a new contact before you can
        reply to this message.</p>
      <br>
      <p>Most of the time Retreva<span style='font-size:9px; vertical-align: super'>&reg;</span> will find the
        match for you based on the tracking tag, If we find the match you will see “Select Contact: Found
        Tracking Tag”. Simply select the contact to match.</p>
      <br>
      <p>If we do not find a match, you have THREE options:</p>
      <br>
      <ul style='margin-left: 30px'>
        <li type='decimal'>Remove: Select remove if there is no reason to match this message to a contact. This is
          typically used for system generated replies. Selecting remove will simply remove the email from your
          inbox.
        </li>
        <li type='decimal'>Search for an existing contact: Enter the contact’s first name, last name or company to
          return options for a potential match.
        </li>
        <li type='decimal'>Add a new contact: This is typically used if a contact forwarded your email to another
          person and you need to add them to your contacts. Note, you will most likely want to disposition the
          contact who forwarded your email so you do not continue to send them campaign emails. You can do
          this by clicking on Contacts and search for the contact.
        </li>
      </ul>
      <br>
      <p>For additional details, please <a href='https://vimeo.com/205784596/edb901f9f1' target='_blank'>view</a>
        the "No Match" Training Video.</p>
    </ng-container>
    <ng-container *ngIf="type === 'notification_email'">
      <p>By default, the notifications and forwards are sent to the account's email address.<br />If you would like the
        listed features to work with a different notification email, please type in the address.<br />You can select
        which features should use the notification emails</p>
    </ng-container>
    <ng-container *ngIf="type === 'send-update'">
      <p>Update and Send do the same thing. The only difference is Update does not send the immediate email. So, if you
        simply want to update the contact to Meeting, Inactive or Remove status and NOT send them an email use Update.
        Also, if you want to schedule the future Follow Up or Cycle but not send the immediate email, use Update. If you
        hit Send, the immediate email will be sent to the contact.</p>
    </ng-container>
    <ng-container *ngIf="type === 'send_email' || type === 'send-email'">
      <p>Send Email is very similar to Conversation. It will open a blank response window and you can type a custom
        reply to your contact. This can be used to check on the status of a quote or opportunity, follow up after a
        sale, really anything you need to communicate with the contact. Unlike Conversation, where the dialog is then
        moved to your inbox to remind you that you have had recent dialog and waits for further action. Send Email does
        not move to the inbox, giving you the ability to use anther reply action or immediately send the contact to a
        campaign.</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_name'">
      <p>New users should type this code while on the sign up form to receive the defined discounts. Give this code to
        your users</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_product'">
      <p>Subscription options are defined as separate products. To avoid discounting the yearly pricing, do not select
        products with "Yearly" in the name</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_option'">
      <p>Can define if the team code can be discount the set upp only, subscription const only or both</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_duration'">
      <p>This is the duration of the team code. Can be applied forever, meaning while the subscription is active, every
        month, discount will be applied, only once or a fixed number of months (billing cycles)</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_expire_at'">
      <p>Can define the expiration date of the code. If set to Aug 10th 2024, user who signs up with it on Aug 11th will
        not receive the discount</p>
      <p>The expiration date should be at least 24 hours from the time of creating the team code</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_times'">
      <p>Can limit how manu sign ups can be done with the team code. If set to 3, the fourth user who uses it will not
        get the discount</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_domains'">
      <p>Comma-separated list of domains</p>
      <p>Can limit to list of domains.</p>
      <p>For example all users with domains "@dmain1.tld" and "@domain2.tld" can avail from the team code. Meaning user
        with email "user@domain1.tld" or "user@dmain2.tld" who use it will receive the discount</p>
    </ng-container>
    <ng-container *ngIf="type === 'discount_additional_const'">
      <p>Fee paid by the manager for every additional user, created by manager in the UI</p>
    </ng-container>
  </div>
</div>
